import { useLocalSearchParams } from 'expo-router';
import { Platform } from 'react-native';
import { KpLiveWorldHomeView } from '@/components/kursi-play-v2/KpLiveWorldHomeView';
import { RuntimeSessionGuard } from '@/features/unified-learning/runtime/screens/RuntimeSessionGuard';
import type { RuntimeBase } from '@/features/unified-learning/runtime/runtimeRoutes';

export function RuntimeHomeScreen({ runtimeBase }: { runtimeBase: RuntimeBase }) {
  const { slug, uid, token } = useLocalSearchParams<{ slug: string; uid: string; token?: string }>();
  const safeSlug = typeof slug === 'string' ? slug : '';
  const safeUid = typeof uid === 'string' ? uid : '';
  const safeToken = typeof token === 'string'
    ? token
    : Platform.OS === 'web' && safeSlug
      ? window.localStorage.getItem(`kursi_play_guest_token:${safeSlug}`) ?? ''
      : '';

  if (!safeSlug || !safeUid) {
    return <RuntimeSessionGuard runtimeBase={runtimeBase} slug={safeSlug} />;
  }

  return <KpLiveWorldHomeView slug={safeSlug} userId={safeUid} guestSessionToken={safeToken} />;
}
